import React, { useEffect } from "react";
import useSearchResults from "./useSearchResults";

const CompanyDocuments = ({ company }) => {
  const { getDocuments, documents } = useSearchResults();

  useEffect(() => {
    getDocuments(company);
  }, [company.siret]);

  const allDocuments = [
    { code: "kbis", name: "KBIS (1/mois)" },
    { code: "annualResults", name: "Comptes annuels" },
    { code: "rbe", name: "RBE" },
    { code: "inseeSituationNotice", name: "Avis situation SIRENE" },
    { code: "inpiSituationNotice", name: "Extrait immatriculation RCS" },
    {
      code: "acts",
      name: "Actes (status, PV AGE, constitutions, modifications, etc)",
    },
  ];

  const getDocumentStatus = (docCode) => {
    // KBIS is always "conditional" regardless of API response
    if (docCode === "kbis") {
      return "conditional";
    }

    if (!documents) {
      return "loading";
    }
    return documents[docCode] ? "available" : "unavailable";
  };

  const renderBadge = (status) => {
    switch (status) {
      case "loading":
        return (
          <span
            className="badge bg-info-subtle text-black-50  ms-2"
            style={{ fontSize: "10px" }}
          >
            vérification...
          </span>
        );
      case "available":
        return (
          <span className="badge bg-success ms-2" style={{ fontSize: "10px" }}>
            disponible
          </span>
        );
      case "unavailable":
        return (
          <span className="badge bg-danger ms-2" style={{ fontSize: "10px" }}>
            indisponible
          </span>
        );
      case "conditional":
        return (
          <span
            className="badge ms-2"
            style={{ fontSize: "10px", backgroundColor: "#7f0a84" }}
          >
            selon disponibilité
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <div className="">
      <div className="my-2">
        <div className="fw-bold mb-2" style={{ fontSize: 14 }}>
          Documents
        </div>
        {allDocuments.map((doc) => {
          const status = getDocumentStatus(doc.code);
          return (
            <div
              key={`doc${doc.code}`}
              className="d-flex align-items-center justify-content-between py-1"
              style={{ fontSize: 12 }}
            >
              <span>{doc.name}</span>
              {renderBadge(status)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CompanyDocuments;
